import leaflet from "leaflet";
import { environment } from "../../../../environments/environment";
const token = environment.mapboxPublickAccessToken;

// This is for defining the base layer, easy to extend or update
export const baseLayers: { [key: string]: L.TileLayer } = {
  Satellite: leaflet.tileLayer(
    "https://api.mapbox.com/styles/v1/mapbox/satellite-streets-v12/tiles/{z}/{x}/{y}?access_token={accessToken}",
    {
      minZoom: 7,
      tileSize: 512,
      zoomOffset: -1,
      //attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
      accessToken: token, // Replace YOUR_MAPBOX_ACCESS_TOKEN with your actual Mapbox API token
    } as L.TileLayerOptions,
  ),

  Dark: leaflet.tileLayer(
    "https://api.mapbox.com/styles/v1/mapbox/dark-v11/tiles/{z}/{x}/{y}?access_token={accessToken}",
    {
      tileSize: 512,
      zoomOffset: -1,
      accessToken: token,
    } as L.TileLayerOptions,
  ),

  Streets: leaflet.tileLayer(
    "https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}?access_token={accessToken}",
    {
      tileSize: 512,
      zoomOffset: -1,
      accessToken: token,
    } as L.TileLayerOptions,
  ),
  Light: leaflet.tileLayer(
    "https://api.mapbox.com/styles/v1/mapbox/light-v10/tiles/{z}/{x}/{y}?access_token={accessToken}",
    {
      tileSize: 512,
      zoomOffset: -1,
      accessToken: token,
    } as L.TileLayerOptions,
  ),
  OSM: leaflet.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
    attribution: "© OpenStreetMap contributors",
  }),
};
